// import { LoadingOverlay } from '@mantine/core';
// import { useState } from 'react';
// import { useTranslation } from 'react-i18next';

import CreateV2 from '@/components/Create_V2';

const CreatePage = () => {
  // const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center mt-[5vh]" style={{ position: 'relative' }}>
      <CreateV2 />
    </div>
  );
};

export default CreatePage;
